import { TAXONOMY } from '../../common/constants';
import MapIconPink from '../../icons/map-icon-pink.svg';
import MapIconOrange from '../../icons/map-icon-orange.svg';
import MapIconGreen from '../../icons/map-icon-green.svg';
import MapIconYellow from '../../icons/map-icon-yellow.svg';

export const transformMapDataImpact = (
    impactLitters,
    filter = TAXONOMY.OBJECT,
) => {
    if (impactLitters && impactLitters.length) {
        return impactLitters.map((litter) => {
            return {
                ...litter,
                id: litter.id,
                position: {
                    lat: parseFloat(
                        litter.photoLocation
                            ? litter.photoLocation.lat
                            : litter.photolocation.lat,
                    ),
                    lng: parseFloat(
                        litter.photoLocation
                            ? litter.photoLocation.long
                            : litter.photolocation.long,
                    ),
                },
                icon: getFilterIcon(filter),
                thumbnail: litter.thumbnail,
                tags: litter.tags,
                activityId: litter.activityId,
            };
        });
    } else {
        return [];
    }
};

function getFilterIcon(filter) {
    switch (filter) {
        case TAXONOMY.OBJECT:
            return MapIconPink;
        case TAXONOMY.BRAND:
            return MapIconOrange;
        case TAXONOMY.CATEGORY:
            return MapIconGreen;
        case TAXONOMY.MATERIAL:
            return MapIconYellow;
        default:
            return MapIconOrange;
    }
}

export const transformMapData = (impactLitters) => {
    if (impactLitters && impactLitters.length) {
        if (impactLitters && impactLitters[0].position) {
            return impactLitters.map((litter) => {
                return {
                    ...litter,
                    position: {
                        lat: parseFloat(litter.position.coords.latitude),
                        lng: parseFloat(litter.position.coords.longitude),
                    },
                };
            });
        } else {
            return [];
        }
    } else {
        return [];
    }
};
